// AI-CONTEXT: See docs/features/datakwaliteitsscore.md
// AI-CONTEXT: See docs/patterns.md#dashboard-static-card
import { useHistory } from 'react-router-dom'
import useDataQualityScore from '../../hooks/useDataQualityScore'
import { dataQualityBand, formatScoreGrowth } from '../../helpers/dashboard/dataQualityDisplay'
import StaticCardLabel from './StaticCardLabel'
import KpiValue from './KpiValue'
import { client } from '../../hooks/Client'

/**
 * KPI-tegel met de datakwaliteitsscore van de organisatie (0–100, bevroren
 * nachtelijke berekening). Kleurband per score; 'voorlopig' zolang de
 * organisatie minder dan 6 maanden data heeft. Zolang de score wordt opgehaald
 * toont de tegel een laadindicator; is die binnen en is er nog geen score
 * (vóór de eerste nachtelijke run), dan pas een streepje — nooit een valse 0.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 * Neemt geen props —
 * de registry geeft `item` door maar deze tegel heeft er niets uit nodig.
 */
const DashboardDataQualityCard = () => {
    const history = useHistory()
    const { stored, growth, loading, error } = useDataQualityScore()

    const score = typeof stored?.Score === 'number' ? stored.Score : null
    const band = dataQualityBand(score)
    // Waar de organisatie vandaan komt, naast waar ze staat (besluit 2026-10-13).
    const growthLine = formatScoreGrowth(growth)

    const openDetail = () => history.push(`/${client}/datakwaliteit`)

    return (
        <div
            className='participation-value-card participation-value-card--clickable'
            role='button'
            tabIndex={0}
            onClick={openDetail}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    openDetail()
                }
            }}
        >
            <StaticCardLabel title='Datakwaliteit' />
            {error ? (
                <p className='participation-value-error'>Score niet geladen</p>
            ) : score === null ? (
                <KpiValue loading={loading} value={null} />
            ) : (
                <>
                    <KpiValue
                        loading={false}
                        value={score}
                        valueClassName={`data-quality-score data-quality-score--${band}`}
                    />
                    <div className='data-quality-bar'>
                        <div
                            className={`data-quality-bar-fill data-quality-bar-fill--${band}`}
                            style={{ width: `${score}%` }}
                        />
                    </div>
                    {growthLine && (
                        <p className={`data-quality-growth data-quality-growth--${growthLine.direction}`}>{growthLine.text}</p>
                    )}
                    {stored?.Provisional && (
                        <p className='data-quality-provisional'>Score voorlopig — minder dan 6 maanden data</p>
                    )}
                </>
            )}
        </div>
    )
}

export default DashboardDataQualityCard
